/**
 * Whether the event panel may run at all, and whether it is switched on.
 *
 * TWO GATES, and they do different jobs.
 *
 * The build gate is NOT here -- it is the inline `import.meta.env.MODE !== 'production'`
 * in `app/index.jsx`, which is what actually keeps this module out of the production
 * bundle. `DEBUG_ALLOWED` below is the same test, kept as a runtime belt-and-braces so
 * that anything importing this module directly still cannot switch the panel on in
 * production. It is not what does the elimination: a constant imported across a module
 * boundary is not propagated into the guard, and a build with only that in place still
 * emitted the debug chunk.
 *
 * `vite build` (the production script) is mode 'production'; `--mode qa`, `--mode test`,
 * `--mode development` and `npm run dev` are not. Verified against real builds: the QA
 * bundle contains the panel chunk and the production bundle contains no trace of it.
 *
 * The second gate is the URL. `?debug=events` turns it on, `?debug=off` turns it off. The
 * choice is remembered in localStorage because the flows worth watching NAVIGATE -- the
 * hero hands off to verification, and `ApiService.save` rewrites the URL with
 * `history.pushState` the moment an offer is created -- and a panel that vanished on the
 * first interesting transition would be useless for exactly the funnel work it exists to
 * support.
 */
const STORAGE_KEY = 'refiDebugEvents';

export const DEBUG_ALLOWED = import.meta.env.MODE !== 'production';

const readParam = (search = window.location.search) => {
    const match = /[?&]debug=([^&]*)/.exec(search);

    return match ? decodeURIComponent(match[1]) : null;
};

const readStored = () => {
    try {
        return window.localStorage.getItem(STORAGE_KEY) === 'on';
    } catch (ex) {
        // Private browsing, or storage disabled. Not a reason to fail.
        return false;
    }
};

const store = on => {
    try {
        if (on) {
            window.localStorage.setItem(STORAGE_KEY, 'on');
        } else {
            window.localStorage.removeItem(STORAGE_KEY);
        }
    } catch (ex) {
        // as above
    }
};

/**
 * @param {String} search  defaults to the live query string; injectable for tests
 */
export const isDebugEnabled = (search = window.location.search) => {
    if (!DEBUG_ALLOWED) {
        return false;
    }

    const param = readParam(search);

    if (param === 'events' || param === 'on' || param === '1') {
        store(true);

        return true;
    }

    if (param === 'off' || param === '0') {
        store(false);

        return false;
    }

    return readStored();
};

export const STORAGE = STORAGE_KEY;
